// extracted by mini-css-extract-plugin
export default {"btop":"_9f3ded8de1 _64726f8990 _35ff5b506c","icon":"_24a12bfa12 d9a8dd43da","btoppink":"_169d77b9be _9822ebdebf"};